<template>
  <div class="assembly-work-order">
    <div class="list-top-margin">
      <el-button type="primary" plain icon="el-icon-plus" size="small" @click="add">添加一行</el-button>
      <el-tooltip class="item" effect="dark" content="最多支持添加50个" placement="right">
        <i class="el-icon-info message-icon"></i>
      </el-tooltip>
      <!-- 最多支持添加50个 -->
    </div>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row max-height="400px" stripe border element-loading-text="拼命加载中" :header-cell-style="_headerStyle" style="width: 100%;">
      <el-table-column type="selection" width="60">
      </el-table-column>
      <el-table-column prop="no" label="序号" type="index" width="50"></el-table-column>
      <el-table-column prop="deptName" label="类型"  width="200">
        <template slot-scope="scope">
          <el-select v-model="scope.row.type" filterable>
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </template>
      </el-table-column>
      <el-table-column  prop="deptNo" label="名称">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.name" placeholder="请填写"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-tooltip content="删除">
            <el-button size="mini" type="primary" icon="el-icon-delete" circle @click="deleteRow(scope.$index, scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import OrderDetail from "@/views/order/dialogManage/order-detail.vue";
export default {
  props:['formData'],
  // 注册组件
  components: {
    Pagination,
    OrderDetail,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
      if(this.formData.dataList && this.formData.dataList.length!=0){
        this.listData = this.formData.dataList
      }
  },
  data() {
    return {
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请请输入部门代码', trigger: 'blur' }]
      },
      form: {
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken'),
        updateCondition:'0',
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      mode:'main',
      orderVisible:false,
      editRow:{},//编辑工序对象
      typeOptions: [{
        value: '文本',
        label: '文本'
      }, {
        value: '数字',
        label: '数字'
      },{
        value: '时间',
        label: '时间'
      }, {
        value: '照片',
        label: '照片'
      }],
    }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    deleteRow(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.listData.splice(index,1)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    add(){
      if(this.listData.length < 50){
        var data = {
          type: '文本',
          name: '',
        }
        this.listData.push(data)
      }else{
        this.$message.warning('最多支持添加50个')
      }
    },
  }
}
</script>

<style scoped>

</style>





// WEBPACK FOOTER //
// src/views/basicData/workProcedure/list-table.vue